<template>
  <div>
    <div>
      <v-card>
        <v-spacer></v-spacer>
        <v-toolbar
            elevation="1"
            color="#BC0000"
            dark
        >
          <v-card-title class="d-flex justify-center pt-1">
            <h2 class="text-center">Adicionar atributo</h2>
          </v-card-title>
          <v-btn color="#ccc" icon @click="close">
            <v-icon size="22">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="text-center">
          <v-form class="mb-6" ref="form" v-model="valid">
            <v-row class="ma-0">
              <v-col cols="12" sm="12" md="8" lg="8">
                <div class="text-start">
                  <span class="label-details ml-2">Nome do atributo</span>
                  <v-text-field
                    clearable
                    outlined
                    hide-details
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    v-model="currentAttribute.name"
                    placeholder="Nome do atributo"
                    class="mt-2"
                    style="border: 1px solid #979797; border-radius: 7.5px"
                    color="black"
                    background-color="#F5F5F5"
                    @keydown.enter="openDialog"
                  ></v-text-field>
                </div>
              </v-col>

              <v-col cols="12" sm="12" md="4" lg="4">
                <div class="text-start">
                  <span class="label-details ml-2">Tipo do Atributo</span>
                  <v-select
                    style="border-radius: 7.5px; font-weight: normal !important"
                    append-icon="mdi-chevron-down"
                    placeholder="Seleção"
                    hide-details
                    class="mt-2"
                    clearable
                    color="white"
                    background-color="normalred"
                    dark
                    outlined
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    :items="attributes"
                    v-model="currentAttribute.type"
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-form>

          <span class="label text-center">
            Atributos do tipo seleção são atributos em que o cliente poderá selecionar um
            tipo. Por exemplo: Tamanho: 2 metros ou 3 metros.
          </span>
        </v-card-text>

        <v-card-actions>
          <v-row class="ma-0">
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              class="d-flex justify-lg-end justify-md-end"
            >
              <v-btn
                class="cancel-button"
                height="50"
                outlined
                width="100%"
                elevation="0"
                @click="close"
              >
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-btn
                class="cadaster-button"
                dark
                height="50"
                width="100%"
                elevation="0"
                @click="openDialog"
              >
                <span>Cadastrar atributo</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>

    <v-dialog v-model="confirmDialog" max-width="500">
      <ConfirmModal
        textMessage="Aviso de alterações"
        cancelBtn="Cancelar"
        title="Atenção"
        okbtn="Sim"
        textObservation1="Se você editar esse atributo, ele será editada em todos os produtos em uso!"
        @close="confirmDialog = false"
        @action="submit"
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.label {
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #9c9c9c;
}

.label-details {
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
}

.cadaster-button {
  border-radius: 7.5px !important;
  transition: 0.3s;
  background: #bc0000 !important;
  font-weight: bold !important;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  font-size: 18px;
  color: #ffffff;
}

.cadaster-button:hover {
  color: white !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.cancel-button {
  border-radius: 7.5px !important;
  border: 2px solid #2d3038;
  box-sizing: border-box;
  font-weight: bold;
  transition: 300ms;
}

.cancel-button:hover {
  background: #2d3038;
  color: white !important;
}

.cancel-button:focus {
  background: #444854;
  color: white !important;
}
</style>

<script scoped>
import ApiService from "../../../../../services/ApiService";
import ConfirmModal from "../../../components/ConfirmModal.vue";
import Vue from "vue";

export default {
  name: "newAttribute",

  props: {
    textMessage: String,
    icone: String,
    title: String,
    route: String,
    typeRoute: String,
    attribute: Object,
  },

  created() {
    if (this.attribute.name != null) {
      this.currentAttribute = this.attribute;

      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
  },

  data: () => ({
    confirmDialog: false,
    valid: false,
    secondValid: true,
    attributes: ["Cor", "Texto"],
    loading: false,
    isEditing: false,
    apiService: new ApiService(),
    currentAttribute: {},

    newAttributeDialog: false,
  }),

  components: {
    ConfirmModal,
  },

  methods: {
    action() {
      this.$emit("action");
    },

    close() {
      this.$emit("close");
    },

    openDialog() {
      if (this.isEditing) {
        this.confirmDialog = true;
      } else {
        this.submit();
      }
    },

    async submit() {
      this.loading = true;

      if (this.$refs.form.validate()) {
        const attribute = this.currentAttribute;
        let url = "attribute/add";
        if (this.isEditing) {
          url = "attribute/edit";
        }

        await this.apiService
          .post(url, attribute)
          .then((resp) => {
            let token = localStorage.getItem("token");
            if (token) {
              this.close();
            } else {
              this.$router.push("/auth");
            }

            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Atributo cadastrado com sucesso!",
              message: resp.message,
              trace: null,
            });

            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar produto",
              message: err.body.message,
              trace: null,
            });

            this.loading = false;
          });
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });

        this.loading = false;
      }
    },
  },
};
</script>
